/**
 * @generated SignedSource<<044f2a1b50736a083aa773821be0554d>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { ReaderFragment, RefetchableFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type designCarousel_versionIssueAssociatedDesigns$data = {
  readonly id: string;
  readonly issueAssociatedDesigns: {
    readonly edges: ReadonlyArray<{
      readonly node: {
        readonly id?: string;
        readonly " $fragmentSpreads": FragmentRefs<"designCard_versionIssueAssociatedDesigns_devOpsDesign">;
      } | null | undefined;
    } | null | undefined> | null | undefined;
    readonly totalCount: number;
  };
  readonly " $fragmentSpreads": FragmentRefs<"designCard_versionIssueAssociatedDesigns_jiraVersion">;
  readonly " $fragmentType": "designCarousel_versionIssueAssociatedDesigns";
};
export type designCarousel_versionIssueAssociatedDesigns$key = {
  readonly " $data"?: designCarousel_versionIssueAssociatedDesigns$data;
  readonly " $fragmentSpreads": FragmentRefs<"designCarousel_versionIssueAssociatedDesigns">;
};

import versionDetailsDesignRefetchableQuery_graphql from './versionDetailsDesignRefetchableQuery.graphql';

const node: ReaderFragment = (function(){
var v0 = [
  "issueAssociatedDesigns"
],
v1 = {
  "kind": "ScalarField",
  "name": "id"
};
return {
  "argumentDefinitions": [
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "after"
    },
    {
      "kind": "RootArgument",
      "name": "cloudAri"
    },
    {
      "defaultValue": 6,
      "kind": "LocalArgument",
      "name": "first"
    }
  ],
  "kind": "Fragment",
  "metadata": {
    "connection": [
      {
        "count": "first",
        "cursor": "after",
        "direction": "forward",
        "path": (v0/*: any*/)
      }
    ],
    "refetch": {
      "connection": {
        "forward": {
          "count": "first",
          "cursor": "after"
        },
        "backward": null,
        "path": (v0/*: any*/)
      },
      "fragmentPathInResult": [
        "node"
      ],
      "operation": versionDetailsDesignRefetchableQuery_graphql,
      "identifierInfo": {
        "identifierField": "id",
        "identifierQueryVariableName": "id"
      }
    }
  },
  "name": "designCarousel_versionIssueAssociatedDesigns",
  "selections": [
    {
      "kind": "FragmentSpread",
      "name": "designCard_versionIssueAssociatedDesigns_jiraVersion"
    },
    {
      "kind": "RequiredField",
      "field": {
        "alias": "issueAssociatedDesigns",
        "args": [
          {
            "kind": "Literal",
            "name": "sort",
            "value": {
              "createdAt": {
                "direction": "DESC",
                "priority": 1
              }
            }
          }
        ],
        "concreteType": "GraphStoreSimplifiedVersionAssociatedDesignConnection",
        "kind": "LinkedField",
        "name": "__DesignSlider_issueAssociatedDesigns_connection",
        "plural": false,
        "selections": [
          {
            "concreteType": "GraphStoreSimplifiedVersionAssociatedDesignEdge",
            "kind": "LinkedField",
            "name": "edges",
            "plural": true,
            "selections": [
              {
                "kind": "LinkedField",
                "name": "node",
                "plural": false,
                "selections": [
                  {
                    "kind": "InlineFragment",
                    "selections": [
                      (v1/*: any*/),
                      {
                        "kind": "FragmentSpread",
                        "name": "designCard_versionIssueAssociatedDesigns_devOpsDesign"
                      }
                    ],
                    "type": "DevOpsDesign"
                  },
                  {
                    "kind": "ScalarField",
                    "name": "__typename"
                  }
                ]
              },
              {
                "kind": "ScalarField",
                "name": "cursor"
              }
            ]
          },
          {
            "kind": "RequiredField",
            "field": {
              "kind": "ScalarField",
              "name": "totalCount"
            },
            "action": "THROW",
            "path": "issueAssociatedDesigns.totalCount"
          },
          {
            "concreteType": "PageInfo",
            "kind": "LinkedField",
            "name": "pageInfo",
            "plural": false,
            "selections": [
              {
                "kind": "ScalarField",
                "name": "endCursor"
              },
              {
                "kind": "ScalarField",
                "name": "hasNextPage"
              }
            ]
          }
        ],
        "storageKey": "__DesignSlider_issueAssociatedDesigns_connection(sort:{\"createdAt\":{\"direction\":\"DESC\",\"priority\":1}})"
      },
      "action": "THROW",
      "path": "issueAssociatedDesigns"
    },
    (v1/*: any*/)
  ],
  "type": "JiraVersion"
};
})();

(node as any).hash = "7979312fd2183c859bc266fe0defac6d";

export default node;
